import React from 'react';
import './Contact.css';

const Contact = () => {
    return (
        <section id='contact' className="md:mx-0 mx-5 mt-28">
            <div>
                <h1 className='text-5xl font-bold text-center' style={{ color: '#65647C' }}>Contact Me</h1>
                <hr className="h-px bg-gray-300 border-0 dark:bg-gray-700 mt-3 mb-10"></hr>
            </div>
            <div className="bgImage grid max-w-6xl grid-cols-1 bg-gray-100 text-white rounded-lg py-20 px-6 mx-auto lg:px-8 md:grid-cols-2 md:divide-x">
                <div className="py-6 md:py-0 md:px-6">
                    <h1 className="text-3xl font-semibold">Get in Touch</h1>
                    <div className="space-y-4 mt-10">
                        <p className="flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 mr-2 sm:mr-6">
                                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"></path>
                            </svg>
                            <span>Chattogram, Bangladesh</span>
                        </p>
                        {/* <p className="flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 mr-2 sm:mr-6">
                                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"></path>
                            </svg>
                            <span>+8801862766744</span>
                        </p> */}
                        <p className="flex items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 mr-2 sm:mr-6">
                                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                            </svg>
                            <span>ehsankhan1997.ek@gmail.com</span>
                        </p>
                    </div>
                </div>
                <form noValidate="" className="flex flex-col py-6 space-y-6 md:py-0 md:px-6 ng-untouched ng-pristine ng-valid">
                    <label className="block">
                        <span className="mb-1">Full name</span>
                        <input type="text" placeholder="enter your full name" className="block w-full rounded-md shadow-sm focus:ring focus:ring-opacity-75 focus:ring-emerald-600 bg-gray-100" />
                    </label>
                    <label className="block">
                        <span className="mb-1">Email address</span>
                        <input type="email" placeholder="enter your email address" className="block w-full rounded-md shadow-sm focus:ring focus:ring-opacity-75 focus:ring-emerald-600 bg-gray-100" />
                    </label>
                    <label className="block">
                        <span className="mb-1">Subject</span>
                        <input type="email" placeholder="enter the subject line" className="block w-full rounded-md shadow-sm focus:ring focus:ring-opacity-75 focus:ring-emerald-600 bg-gray-100" />
                    </label>
                    <label className="block">
                        <span className="mb-1">Message</span>
                        <textarea rows="3" placeholder='write your message' className="block w-full rounded-md focus:ring focus:ring-opacity-75 focus:ring-emerald-600 bg-gray-100"></textarea>
                    </label>
                    <button type="button" className="text-white bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2">Submit</button>
                </form>
            </div>
        </section>
    );
};

export default Contact;